import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPlus, FaSearch, FaSync, FaPen, FaFileInvoice, FaEllipsisV, FaTimes, FaTrash, FaFileExcel } from 'react-icons/fa';
import ReactSelect from '../../components/ReactSelect';
import TabelaLoading from '../../components/TabelaLoading';
import TabelaVazia from '../../components/TabelaVazia';
import api from '../../services/api';
import { moeda } from '../../util/util';
import '../../css/financeiro-parcela-pagar.css';

const STATUS_OPTIONS = [
    { value: '', label: 'Todos os status' },
    { value: 'aguardando', label: '⏳ Aguardando' },
    { value: 'recebida', label: '📬 Recebida' },
    { value: 'aprovada', label: '✅ Aprovada' },
    { value: 'rejeitada', label: '❌ Rejeitada' },
    { value: 'cancelada', label: '🚫 Cancelada' },
    { value: 'substituida', label: '🔄 Substituída' },
];

const STATUS_PILL = {
    aguardando:  'is-warn',
    recebida:    'is-info',
    aprovada:    'is-ok',
    rejeitada:   'is-danger',
    cancelada:   'is-muted',
    substituida: 'is-muted',
};

const STATUS_LABEL = {
    aguardando:  '⏳ Aguardando',
    recebida:    '📬 Recebida',
    aprovada:    '✅ Aprovada',
    rejeitada:   '❌ Rejeitada',
    cancelada:   '🚫 Cancelada',
    substituida: '🔄 Substituída',
};

export default function PainelNotaFiscal() {
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem('perfil');
    const podeEditar = ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro'].includes(perfil);
    const podeExcluir = ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'].includes(perfil);

    const [filtro, setFiltro] = useState({
        numero: '',
        status: '',
        data_inicio: '',
        data_fim: '',
        buscando: false,
    });
    const [notas, setNotas] = useState([]);
    const [marcandoContabilidade, setMarcandoContabilidade] = useState(null);
    const [actionsSheet, setActionsSheet] = useState({ open: false, nf: null });
    const [deleteModal, setDeleteModal] = useState({ open: false, nf: null, loading: false });

    const marcarEnviadaContabilidade = (nfId) => {
        setMarcandoContabilidade(nfId);
        api({ method: 'post', action: '/notaFiscal/' + nfId + '/marcarEnviadaContabilidade', token })
            .then(() => { buscar(); })
            .catch(err => {
                var msg = err?.response?.data?.error || 'Erro ao marcar NF como enviada.';
                alert(msg);
            })
            .finally(() => setMarcandoContabilidade(null));
    };

    const buscar = () => {
        setFiltro(prev => ({ ...prev, buscando: true }));
        const params = {};
        if (filtro.numero) params.numero = filtro.numero;
        if (filtro.status) params.status = filtro.status;
        if (filtro.data_inicio) params.data_inicio = filtro.data_inicio;
        if (filtro.data_fim) params.data_fim = filtro.data_fim;

        api({ method: 'get', action: '/notaFiscal', token, params })
            .then(response => {
                setNotas(response.data.data ?? []);
                setFiltro(prev => ({ ...prev, buscando: false }));
            })
            .catch((err) => {
                console.error('[PainelNotaFiscal] erro ao buscar NFs:', err?.response?.status, err?.response?.data || err?.message);
                setFiltro(prev => ({ ...prev, buscando: false }));
            });
    };

    // Exportação para a contabilidade (pedido da Nara): uma linha por nota do
    // período, atravessando eventos. O endpoint exige período — usa o mesmo
    // filtro De/Até da tela. O formato da planilha ainda pode mudar depois da
    // reunião Otávio+Nara; o botão e o recorte por período ficam.
    const [exportando, setExportando] = useState(false);
    const exportarContabilidade = async () => {
        if (!filtro.data_inicio || !filtro.data_fim) {
            alert('Preencha o período (De / Até) no filtro — a exportação é por período.');
            return;
        }
        setExportando(true);
        try {
            const qs = new URLSearchParams({ data_inicio: filtro.data_inicio, data_fim: filtro.data_fim });
            const response = await fetch(
                process.env.REACT_APP_API_URL + '/notaFiscal/exportarContabilidade?' + qs.toString(),
                { headers: { Authorization: 'Bearer ' + token } }
            );
            if (!response.ok) {
                let msg = 'Falha ao gerar a planilha.';
                try { const j = JSON.parse(await response.text()); msg = j.mensagem || j.error || msg; } catch (e) {}
                throw new Error(msg);
            }
            const blob = await response.blob();
            const cd = response.headers.get('content-disposition') || '';
            const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            const nome = (m?.[1] || ('notas-fiscais-' + filtro.data_inicio + '-a-' + filtro.data_fim + '.xlsx')).replace(/['"]/g, '');
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url; link.download = nome;
            document.body.appendChild(link); link.click(); document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            alert(err.message || 'Erro ao gerar a planilha.');
        } finally {
            setExportando(false);
        }
    };

    const excluirNF = () => {
        setDeleteModal(prev => ({ ...prev, loading: true }));
        api({ method: 'delete', action: '/notaFiscal/' + deleteModal.nf.id, token })
            .then(() => {
                setDeleteModal({ open: false, nf: null, loading: false });
                buscar();
            })
            .catch(err => {
                var msg = err?.response?.data?.error || 'Erro ao excluir NF.';
                alert(msg);
                setDeleteModal(prev => ({ ...prev, loading: false }));
            });
    };

    useEffect(() => {
        buscar();
        // eslint-disable-next-line
    }, []);

    var pendentesContabilidade = notas.filter(function(n) {
        return n.is_retroativa && n.valor_retencoes > 0 && !n.enviada_contabilidade_em;
    });

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">

                {/* ── Header ──────────────────────────────────────────────── */}
                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">Notas Fiscais</h2>
                        <p className="fin-pp__subtitle">Gestão de NF-e e NFS-e</p>
                    </div>
                    <div className="fin-pp__actions">
                        {podeEditar && (
                            <Link to="/cadastroNotaFiscal" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                                <FaPlus size={14} style={{ marginRight: 6 }} /> Nova Nota Fiscal
                            </Link>
                        )}
                        <button type="button" className="fin-pp__btn fin-pp__btn--pill"
                            onClick={exportarContabilidade} disabled={exportando}
                            title="Planilha com uma linha por nota do período (De/Até do filtro), para a contabilidade">
                            <FaFileExcel size={14} style={{ marginRight: 6 }} /> {exportando ? 'Gerando...' : 'Exportar p/ contabilidade'}
                        </button>
                        <Link to="/financeiro" className="fin-pp__btn fin-pp__btn--pill">
                            <FaFileInvoice size={14} style={{ marginRight: 6 }} /> Financeiro
                        </Link>
                    </div>
                </div>

                {/* ── Alerta NFs retroativas ───────────────────────────────── */}
                {pendentesContabilidade.length > 0 && (
                    <div className="fin-pp__card" style={{
                        marginBottom: 16,
                        padding: '14px 16px',
                        borderLeft: '4px solid var(--fin-wn)',
                        background: '#fff8e1',
                    }}>
                        <div style={{ fontWeight: 600, color: 'var(--fin-wn)', fontSize: '0.87rem', marginBottom: 6 }}>
                            ⚠️ {pendentesContabilidade.length} NF{pendentesContabilidade.length !== 1 ? 's' : ''} retroativa{pendentesContabilidade.length !== 1 ? 's' : ''} com retenção fiscal pendente{pendentesContabilidade.length !== 1 ? 's' : ''} de envio à contabilidade
                        </div>
                        <div style={{ fontSize: '0.8rem', color: '#78350f', marginBottom: 10 }}>
                            NFs retroativas com retenção são obrigação fiscal e não podem ser esquecidas. Marque cada uma como enviada após o repasse ao contador.
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                            {pendentesContabilidade.map(function(n) {
                                return (
                                    <span key={n.id} className="fin-pp__pill is-warn" style={{ fontSize: '0.72rem' }}>
                                        NF {n.numero || n.id} · {n.fornecedor ? (n.fornecedor.nomefantasia || n.fornecedor.nome) : '—'}
                                        · R$ {(n.valor_retencoes || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* ── Filtros ──────────────────────────────────────────────── */}
                <div className="fin-pp__card" style={{ padding: '14px 16px', marginBottom: 14 }}>
                    <form onSubmit={e => { buscar(); e.preventDefault(); }}>
                        <div className="fin-pp__filters">
                            <div className="fin-pp__field" style={{ flex: '0 0 140px' }}>
                                <label className="fin-pp__label">Número</label>
                                <input
                                    type="text"
                                    className="fin-pp__input"
                                    style={{ paddingLeft: 14 }}
                                    placeholder="N.º da NF"
                                    value={filtro.numero}
                                    onChange={e => setFiltro({ ...filtro, numero: e.target.value })}
                                />
                            </div>
                            <div className="fin-pp__field" style={{ flex: '1 1 200px' }}>
                                <label className="fin-pp__label">Status</label>
                                <ReactSelect
                                    options={STATUS_OPTIONS}
                                    value={STATUS_OPTIONS.find(o => o.value === filtro.status) || STATUS_OPTIONS[0]}
                                    onChange={opt => setFiltro({ ...filtro, status: opt ? opt.value : '' })}
                                />
                            </div>
                            <div className="fin-pp__field" style={{ flex: '0 0 160px' }}>
                                <label className="fin-pp__label">Emissão de</label>
                                <input
                                    type="date"
                                    className="fin-pp__input"
                                    style={{ paddingLeft: 14 }}
                                    value={filtro.data_inicio}
                                    onChange={e => setFiltro({ ...filtro, data_inicio: e.target.value })}
                                />
                            </div>
                            <div className="fin-pp__field" style={{ flex: '0 0 160px' }}>
                                <label className="fin-pp__label">Emissão até</label>
                                <input
                                    type="date"
                                    className="fin-pp__input"
                                    style={{ paddingLeft: 14 }}
                                    value={filtro.data_fim}
                                    onChange={e => setFiltro({ ...filtro, data_fim: e.target.value })}
                                />
                            </div>
                            <div className="fin-pp__field" style={{ flex: '0 0 auto', alignSelf: 'flex-end' }}>
                                <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall" disabled={filtro.buscando}>
                                    <FaSearch size={13} style={{ marginRight: 6 }} />
                                    {filtro.buscando ? 'Buscando…' : 'Buscar'}
                                </button>
                            </div>
                            <div className="fin-pp__field" style={{ flex: '0 0 auto', alignSelf: 'flex-end' }}>
                                <button type="button" className="fin-pp__btn fin-pp__btn--tall" onClick={buscar} disabled={filtro.buscando}>
                                    <FaSync size={11} className={filtro.buscando ? 'fa-spin' : ''} />
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                {/* ── Tabela ───────────────────────────────────────────────── */}
                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap" style={{ containerType: "inline-size" }}>
                        <table className="fin-pp__tbl" style={{ minWidth: 1100, tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}></th>
                                    <th style={{ width: 130 }}>Status</th>
                                    <th style={{ width: 100 }}>Número</th>
                                    <th style={{ width: 70 }}>Tipo</th>
                                    <th>Fornecedor</th>
                                    <th>Evento</th>
                                    <th style={{ width: 105 }}>Emissão</th>
                                    <th style={{ width: 110 }}>Competência</th>
                                    <th style={{ width: 120, textAlign: 'right' }}>Bruto</th>
                                    <th style={{ width: 120, textAlign: 'right' }}>Retenções</th>
                                    <th style={{ width: 120, textAlign: 'right' }}>Líquido</th>
                                    <th style={{ width: 90 }}>Retroativa</th>
                                    <th style={{ width: 145 }}>Contabilidade</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtro.buscando ? (
                                    <tr>
                                        <td colSpan={13} className="fin-pp__empty" style={{ padding: 0 }}>
                                            <TabelaLoading texto="Buscando notas fiscais…" />
                                        </td>
                                    </tr>
                                ) : notas.length === 0 ? (
                                    <tr>
                                        <td colSpan={13} className="fin-pp__empty" style={{ padding: 0 }}>
                                            <TabelaVazia texto="Nenhuma nota fiscal encontrada" />
                                        </td>
                                    </tr>
                                ) : notas.map(function(row) {
                                    var pillClass = STATUS_PILL[row.status] || 'is-muted';
                                    var statusLabel = STATUS_LABEL[row.status] || row.status;
                                    var fornecedor = row.fornecedor ? (row.fornecedor.nomefantasia || row.fornecedor.nome || '—') : '—';
                                    var fornecedorCnpj = row.fornecedor ? row.fornecedor.cnpj : null;
                                    var eventoNome = row.evento ? row.evento.nome : '—';
                                    var eventoCodigo = row.evento ? row.evento.codigo : null;
                                    var emissao = row.data_emissao
                                        ? new Date(row.data_emissao + 'T12:00:00').toLocaleDateString('pt-BR')
                                        : '—';
                                    var competencia = row.data_competencia
                                        ? new Date(row.data_competencia + 'T12:00:00').toLocaleDateString('pt-BR', { month: '2-digit', year: 'numeric' })
                                        : '—';

                                    return (
                                        <tr key={row.id}>
                                            <td>
                                                {(podeEditar || podeExcluir) && (
                                                    <button
                                                        className="fin-pp__rowbtn"
                                                        title="Ações"
                                                        onClick={() => setActionsSheet({ open: true, nf: row })}
                                                    >
                                                        <FaEllipsisV size={14} />
                                                    </button>
                                                )}
                                            </td>
                                            <td>
                                                <span className={'fin-pp__pill ' + pillClass} style={{ fontSize: '0.72rem' }}>
                                                    {statusLabel}
                                                </span>
                                            </td>
                                            <td className="fin-pp__cell-strong">{row.numero ?? '—'}</td>
                                            <td className="fin-pp__cell-muted">{(row.tipo ?? '').toUpperCase() || '—'}</td>
                                            <td>
                                                <div className="fin-pp__cell-strong">{fornecedor}</div>
                                                {fornecedorCnpj && <div className="fin-pp__cell-muted">{fornecedorCnpj}</div>}
                                            </td>
                                            <td>
                                                <div className="fin-pp__cell-strong">{eventoNome}</div>
                                                {eventoCodigo && <div className="fin-pp__cell-muted">{eventoCodigo}</div>}
                                            </td>
                                            <td className="fin-pp__cell-muted">{emissao}</td>
                                            <td className="fin-pp__cell-muted">{competencia}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                <strong>{moeda(row.valor_bruto ?? 0)}</strong>
                                            </td>
                                            <td style={{ textAlign: 'right', color: 'var(--fin-dg)' }}>
                                                {row.valor_retencoes > 0 ? '− ' + moeda(row.valor_retencoes) : '—'}
                                            </td>
                                            <td style={{ textAlign: 'right', color: 'var(--fin-ok)', fontWeight: 700 }}>
                                                {moeda(row.valor_liquido ?? 0)}
                                            </td>
                                            <td>
                                                {row.is_retroativa && (
                                                    <span className="fin-pp__pill is-warn" style={{ fontSize: '0.72rem' }}>⚠ Sim</span>
                                                )}
                                            </td>
                                            <td>
                                                {row.is_retroativa && row.valor_retencoes > 0 && (
                                                    row.enviada_contabilidade_em ? (
                                                        <span className="fin-pp__pill is-ok" style={{ fontSize: '0.72rem' }}
                                                            title={'Enviada por ' + (row.enviada_contabilidade_por || '—')}>
                                                            ✅ {new Date(row.enviada_contabilidade_em).toLocaleDateString('pt-BR')}
                                                        </span>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="fin-pp__btn fin-pp__btn--sm"
                                                            style={{ fontSize: '0.7rem' }}
                                                            disabled={marcandoContabilidade === row.id}
                                                            onClick={() => marcarEnviadaContabilidade(row.id)}
                                                        >
                                                            {marcandoContabilidade === row.id ? '…' : '📤 Marcar enviada'}
                                                        </button>
                                                    )
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">
                            {notas.length} nota{notas.length !== 1 ? 's' : ''} fiscal{notas.length !== 1 ? 'is' : ''}
                        </div>
                    </div>
                </div>

            </div>

            {/* ── Action sheet ─────────────────────────────────────────────── */}
            {actionsSheet.open && actionsSheet.nf && (
                <div className="fin-pp fin-pp__sheet-backdrop" onClick={() => setActionsSheet({ open: false, nf: null })}>
                    <div className="fin-pp__sheet" onClick={e => e.stopPropagation()}>
                        <div className="fin-pp__sheet-head">
                            <span className="fin-pp__sheet-head-ic"><FaEllipsisV size={17} /></span>
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <h3 className="fin-pp__sheet-title">Ações</h3>
                                <p className="fin-pp__sheet-sub">
                                    NF {actionsSheet.nf.numero || actionsSheet.nf.id}
                                    {actionsSheet.nf.fornecedor ? ' · ' + (actionsSheet.nf.fornecedor.nomefantasia || actionsSheet.nf.fornecedor.nome) : ''}
                                </p>
                            </div>
                            <button type="button" className="fin-pp__sheet-close" onClick={() => setActionsSheet({ open: false, nf: null })}>
                                <FaTimes size={16} />
                            </button>
                        </div>
                        <div className="fin-pp__sheet-body">
                            {podeEditar && (
                                <Link
                                    to={'/cadastroNotaFiscal/' + actionsSheet.nf.id}
                                    className="fin-pp__sheet-item"
                                    onClick={() => setActionsSheet({ open: false, nf: null })}
                                >
                                    <span className="fin-pp__sheet-item-ic is-ok"><FaPen size={15} /></span>
                                    <span className="fin-pp__sheet-item-txt">
                                        <span className="fin-pp__sheet-item-label">Editar nota fiscal</span>
                                        <span className="fin-pp__sheet-item-desc">Alterar dados, retenções e vínculos</span>
                                    </span>
                                </Link>
                            )}
                            {podeExcluir && (
                                <button
                                    type="button"
                                    className="fin-pp__sheet-item"
                                    onClick={() => {
                                        setDeleteModal({ open: true, nf: actionsSheet.nf, loading: false });
                                        setActionsSheet({ open: false, nf: null });
                                    }}
                                >
                                    <span className="fin-pp__sheet-item-ic is-muted"><FaTrash size={15} /></span>
                                    <span className="fin-pp__sheet-item-txt">
                                        <span className="fin-pp__sheet-item-label">Excluir nota fiscal</span>
                                        <span className="fin-pp__sheet-item-desc">Remove permanentemente</span>
                                    </span>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal confirmar exclusão ──────────────────────────────────── */}
            {deleteModal.open && deleteModal.nf && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                    onClick={e => { if (e.target === e.currentTarget && !deleteModal.loading) setDeleteModal({ open: false, nf: null, loading: false }); }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger"><FaTrash size={17} /></span>
                                <h3 className="fin-pp__modal-title">
                                    Excluir Nota Fiscal
                                    <span className="fin-pp__modal-sub">
                                        NF {deleteModal.nf.numero || deleteModal.nf.id}
                                        {deleteModal.nf.fornecedor ? ' · ' + (deleteModal.nf.fornecedor.nomefantasia || deleteModal.nf.fornecedor.nome) : ''}
                                    </span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" disabled={deleteModal.loading}
                                    onClick={() => setDeleteModal({ open: false, nf: null, loading: false })}>
                                    <FaTimes size={16} />
                                </button>
                            </div>
                            <div className="modal-body" style={{ padding: '18px 24px' }}>
                                <p style={{ margin: 0, color: 'var(--fin-tx)', fontSize: '0.9rem' }}>
                                    Tem certeza que deseja excluir esta nota fiscal? Esta ação não pode ser desfeita.
                                </p>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn"
                                    disabled={deleteModal.loading}
                                    onClick={() => setDeleteModal({ open: false, nf: null, loading: false })}>
                                    Cancelar
                                </button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger"
                                    disabled={deleteModal.loading}
                                    onClick={excluirNF}>
                                    {deleteModal.loading ? 'Excluindo…' : 'Excluir'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </ErpTemplate>
    );
}
